import React from 'react';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcConfItem from 'components/molecules/PcConfItem';
import PcModal from 'components/molecules/PcModal';

import './index.pc.scss';


const PresentPC = ({ 
  onClickMainButton,
  changeModifyMode,
  confList,
  isApiError,
  showLoading,
  modalIsOpen,
  acknowledgeMap,
  onClickLastButton,
  onClickCloseButton,
  lpMode,
}) => (
  <div className="Conf-PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
      lpMode={lpMode}
    >
      {confList.map(conf => (
        <div key={conf.title} className="conf-item">
          <PcConfItem
            title={conf.title}
            modifyLinks={conf.modifyLinks}
            type={conf.type}
            items={conf.items}
            changeModifyMode={changeModifyMode}
          />
        </div>
      ))}
      <PcModal 
        modalIsOpen={modalIsOpen}
        acknowledgeMap={acknowledgeMap}
        onClickCloseButton={onClickCloseButton}
        onClickLastButton={onClickLastButton}
      />
    </PcBasicTemplate>
  </div>
);


export default PresentPC;
